<template>
  <!-- Prompt for Authenticator Registration -->
  <vs-prompt
    title="Setup 2FA"
    accept-text="Verify & Activate"
    @cancel="closePrompt"
    @accept="accepted"
    @close="closePrompt"
    :active.sync="activeSync"
    :is-valid="otp.length === 6"
  >
    <div class="con-2fa-otp-prompt" v-if="!qrCodeError">
      <div>
        <p>
          <strong>
            Please scan the QR code below with your Authenticator app
            (recommended: Google Authenticator App - <a
              href="https://apps.apple.com/us/app/google-authenticator/id388497605"
              target="_blank"
              rel="noopener noreferrer"
              >iOS</a
            >/<a
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US&pli=1"
              target="_blank"
              rel="noopener noreferrer"
              >Android</a
            >) with your mobile phone to complete the setup.
          </strong>
        </p>
        <br />
        <div class="centered" v-if="qrCodeUrl">
          <qrcode-vue :value="qrCodeUrl" size="200" />
        </div>
        <br />
        <div v-if="authenticatorRegistrationCode">
          <p>
            <strong
              >Or, copy and enter below code into the Authenticator app:</strong
            >
          </p>
          <div class="centered" style="align-items: center;">
            <p class="authenticator-code">
              {{ authenticatorRegistrationCode }}
            </p>
            <copy-icon
              size="1.5x"
              class="custom-class pointer"
              @click="copyAuthenticatorCode"
            ></copy-icon>
          </div>
        </div>
        <br />
        <p>
          <strong>
            Once you have setup the Authenticator, please copy the OTP you see
            and paste the OTP into the box below for verification.
          </strong>
        </p>
        <vs-input type="text" v-model="otp" />
      </div>
    </div>
    <div v-else>
      <p>
        There is an error in loading the QR Code. Please refresh the page and
        try again.
      </p>
    </div>
  </vs-prompt>
</template>

<script>
import { mapGetters } from 'vuex';
import { CopyIcon } from 'vue-feather-icons';

import QrcodeVue from 'qrcode.vue';

export default {
  components: {
    QrcodeVue,
    CopyIcon,
  },
  props: {
    active: Boolean,
    qrCodeUrl: String,
    authenticatorRegistrationCode: String,
    qrCodeError: Boolean,
  },
  data() {
    return {
      activeSync: this.active,
      otp: '',
    };
  },
  computed: {
    ...mapGetters(['entityAdmin2FATypeGetter']),
  },
  watch: {
    entityAdmin2FATypeGetter: function(newVal, oldVal) {
      if (this.debugConsole) {
        console.log('EntityAdminGetter OldVal', oldVal);
        console.log('EntityAdminGetter NewVal', newVal);
      }
    },
    activeSync: function(val) {
      this.$emit('update:active', val);
    },
    active: function(val) {
      this.activeSync = val;
      if (val) {
        this.otp = '';
      }
    },
  },
  mounted() {},

  methods: {
    copyAuthenticatorCode() {
      this.copyToClipboard(this.authenticatorRegistrationCode);
    },
    closePrompt() {},
    accepted() {
      this.$emit('verify', this.otp);
    },
  },
};
</script>

<style scoped>
.centered {
  display: flex;
  justify-content: center;
}

.authenticator-code {
  padding: 5px;
  border: 1px solid grey;
  border-radius: 5px;
  width: fit-content;
}

.pointer {
  margin-left: 10px;
  cursor: pointer;
}
</style>
